(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ballr-inquiry-entry"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const anchor = event.target.closest('[data-inquiry-entry] a');
  if (!anchor) return;
  const url = new URL(anchor.href);
  const current = new URL(location.href);
  if (current.searchParams.get('site') === 'global') url.searchParams.set('site', 'global');
  const country = current.searchParams.get('country');
  if (country && /^[A-Z]{2}$/.test(country)) url.searchParams.set('country', country);
  if (url.searchParams.get('inquiry_source') === 'product') {
    const variant = anchor.closest('.buy-buttons-block')?.querySelector('input[name="id"]')?.value;
    if (variant && /^\d+$/.test(variant)) url.searchParams.set('variant', variant);
  }
  anchor.href = url.href;
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ballr-klarna-payment"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ballr-payment-details')) {
    customElements.define('ballr-payment-details', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const dialog = this.querySelector('dialog');
        this.querySelector('[data-klarna-open]').addEventListener('click', () => dialog.showModal());
        this.querySelector('[data-klarna-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-summary"] && !Shopify.designMode) return;
  try {
    // Native cart POST ignores empty attributes. Confirm the explicit update first,
  // then let the existing cart form preserve quantities, notes and checkout flow.
  const invoicePass = new WeakSet();
  const invoicePending = new WeakSet();
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id !== 'cart-form') return;
    if (invoicePass.has(form)) {
      invoicePass.delete(form);
      return;
    }
    const fields = Array.from(form.elements).filter((field) =>
      field.matches?.('.ballr-company-invoice input, .ballr-company-invoice textarea')
    );
    if (!fields.length || !fields.some((field) => field.value !== field.defaultValue)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (invoicePending.has(form)) return;
    const widget = fields[0].closest('.ballr-company-invoice');
    const error = widget.querySelector('.ballr-company-invoice__error');
    const submitter = event.submitter;
    const attributes = Object.fromEntries(fields.map((field) => [field.name.slice(11, -1), field.value.trim()]));
    invoicePending.add(form);
    error.hidden = true;
    form.setAttribute('aria-busy', 'true');
    fields.forEach((field) => { field.readOnly = true; });
    if (submitter) submitter.disabled = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(widget.dataset.updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }),
        signal: controller.signal,
      });
      if (!response.ok) throw new Error('Invoice details not saved');
      const result = await response.json();
      if (!Object.entries(attributes).every(([key, value]) => (result.attributes?.[key] || '') === value)) {
        throw new Error('Invoice details not confirmed');
      }
      fields.forEach((field) => {
        field.value = attributes[field.name.slice(11, -1)];
        field.defaultValue = field.value;
        field.readOnly = false;
      });
      if (submitter) submitter.disabled = false;
      invoicePass.add(form);
      form.requestSubmit(submitter || undefined);
    } catch {
      widget.open = true;
      error.textContent = widget.dataset.language === 'zh'
        ? '公司资料未保存，请检查网络后重试。已填写内容仍保留，尚未进入结账。'
        : widget.dataset.language === 'pt'
          ? 'Não foi possível guardar os dados. Verifique a ligação e tente novamente. Os dados preenchidos foram mantidos; o pagamento ainda não foi iniciado.'
          : 'Invoice details could not be saved. Check your connection and try again. Your entries are still here; checkout has not started.';
      error.hidden = false;
    } finally {
      clearTimeout(timeout);
      fields.forEach((field) => { field.readOnly = false; });
      if (submitter) submitter.disabled = false;
      form.removeAttribute('aria-busy');
      invoicePending.delete(form);
    }
  }, true);
  } catch(e) { console.error(e); }
})();

})();
